export default __webpack_public_path__ + "static/media/av3.e429e25e.jpg";